import { useViewport } from 'contexts/viewport';
import { useHistory } from 'react-router-dom';
import { Button, Container, Stack, Text, styled } from 'shell/components';

const ErrorPage = () => {
    const history = useHistory();
    const { device } = useViewport();

    return (
        <Container device={device}>
            <Stack alignItems={'center'} spacing={4}>
                <Text align={'center'} color={'light'} variant={'h6'} weight={'semibold'}>
                    The page you are looking for couldn't be found.
                </Text>
                <Button align={'center'} variant={'borderless'} onClick={() => history.push('/')}>
                    Back to Home
                </Button>
            </Stack>
            <CustomText>Debug: {process.env.REACT_APP_GIT_TAG}</CustomText>
        </Container>
    );
};

const CustomText = styled(Text)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: theme.spacing(1),
        right: theme.spacing(1),
    };
});

export default ErrorPage;
